import { faUserAlt, faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { Trans } from "react-i18next";

import { Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { BoxLink } from "@unauthenticated/shared/components/BoxLink/BoxLink";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./ImAPatientButton.styles";

const ImAPatientButton = () => {
  const { phone } = useBreakpoints();

  const renderMobileText = () => {
    if (phone.greaterThan) {
      return (
        <Trans i18nKey={l.practitionerSignUp.ImAPatient}>
          I'm a <strong>patient</strong> - Help me get started
        </Trans>
      );
    }

    return (
      <Trans i18nKey={l.practitionerSignUp.ImAPatientMobile}>
        Take me to <strong>patient</strong> sign-up
      </Trans>
    );
  };

  return (
    <BoxLink to={authRoutes.patient_sign_up} css={styles.boxLink}>
      {!!phone.greaterThan && <FontAwesomeIcon icon={faUserAlt} size="lg" css={styles.userIcon} />}
      <Typography isMarginless>{renderMobileText()}</Typography>
      <FontAwesomeIcon
        icon={faArrowRight}
        size="lg"
        css={styles.arrowIcon}
        className="icon-right"
      />
    </BoxLink>
  );
};

export { ImAPatientButton };
